/**
 * Converts a given value into a SQL-safe date string ("YYYY-MM-DD").
 * 
 * Supports Excel numeric dates and standard date strings.
 * Returns null for empty, invalid, placeholder, or out-of-range values.
 *
 * @param {string | number | null | undefined} value
 * @returns {string | null}
 */
export const convertToDateTime = (value) => {
  if (value === null || value === undefined || value === '') return null;

  let d;

  if (typeof value === 'number' && value > 10000) {
    const excelStartDate = new Date(1899, 11, 31);
    d = new Date(excelStartDate.getTime() + value * 86400000);
  } else {
    const strVal = String(value).trim();
    const skipValues = ['-', '`', 'n/a', 'na', 'none', '.', 'undefined'];

    if (skipValues.includes(strVal.toLowerCase()) || /^\d{4}$/.test(strVal)) {
      return null;
    }

    d = new Date(strVal);
  }

  if (!isNaN(d.getTime())) {
    const year = d.getFullYear();
    if (year >= 1753 && year <= 9999) {
      return d.toISOString().split('T')[0];
    }
  }

  return null;
};